import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/INKBOARD9.png'


const _withScopeId = n => (_pushScopeId("data-v-1ec87f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mockup-1" }
const _hoisted_2 = { class: "mockups items-end mt-0 grid lg:mt-52 lg:grid-cols-2 md:grid-cols-1" }
const _hoisted_3 = { class: "element relative z-0 flex flex-wrap justify-center h-full items-center text-left col-span-1 ml-0 pr-0 order-2 lg:mr-24 lg:order-1" }
const _hoisted_4 = { class: "content py-6 pt-8 lg:py-0 lg:pt-0" }
const _hoisted_5 = { class: "text-white pb-4 text-2xl md:text-3xl lg:text-5xl" }
const _hoisted_6 = { class: "text-gray-200 text-base md:text-base lg:text-base" }
const _hoisted_7 = { class: "text-white pb-4 pt-8 text-2xl md:text-3xl lg:text-5xl" }
const _hoisted_8 = { class: "text-gray-200 text-base md:text-base lg:text-base" }
const _hoisted_9 = { class: "video-action flex items-center z-50 py-1 cursor-pointer text-white pt-0 justify-left pt-8 lg:justify-left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cut element relative z-0 flex flex-wrap justify-center mx-auto mx-2 pb-0 col-span-1 order-1 lg:order-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mock flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "z-10 mocks",
      src: _imports_0
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VideoPlayerModal = _resolveComponent("VideoPlayerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.title-1-line-1')) + " " + _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.title-1-line-2')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.text-1')), 1),
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.title-2-line-1')) + " " + _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.title-2-line-2')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards1.text-2')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, {
                class: "h-4 w-4",
                icon: ['fas', 'play-circle']
              }),
              _createElementVNode("h4", {
                class: "pl-2 hover:text-white",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideo()))
              }, _toDisplayString(_ctx.$t('components.general.watch-video')), 1)
            ])
          ])
        ]),
        _hoisted_10
      ])
    ]),
    (_ctx.isShowVideo)
      ? (_openBlock(), _createBlock(_component_VideoPlayerModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowVideo=false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}